import React, { useEffect, useState } from "react";
import ApprovedListCard from "./ApprovedListCard";
import { Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "components/pagination/Pagination";
import { setApprovedRecentBooking } from "redux/actions/super-admin/ApprovedRecentBookingsAction";
import pendingReq from "../../../../../assets/img/icons/customIcons/pending-req.svg";

function ApprovedList({
  handleEmployeeSearchOnChange,
  handleSearch,
  searchFormData,
  data,
  companyId,
  toggle,
  list,
  handleClearDate,
}) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [showToggle, setShowToggle] = useState(false);

  const fetchResultApprovedListRequests = useSelector(
    (state) => state.ApprovedRecentBookingReducer.result
  );

  const fetchResultApprovedListRequestsLoader = useSelector(
    (state) => state.ApprovedRecentBookingReducer.loader
  );

  useEffect(() => {
    setTitle(data);

    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handlePagination = (tab) => {
    const finalData = {
      ...searchFormData,
      page: tab,
    };

    dispatch(
      setApprovedRecentBooking("1", "1", "approved", finalData, companyId)
    );
  };
  return (
    <div>
      <Row className="mb-2">
        <Col md="12">
          <h3 className="tab-title">{`${title} (${
            fetchResultApprovedListRequests?.itemCount
              ? fetchResultApprovedListRequests?.itemCount
              : "0"
          })`}</h3>
        </Col>
        {/* <Col lg="7" md="12">
          <AnimatedSearchBar
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleSearch}
          />
        </Col> */}
        <Col lg="5" md="12">
          <div className="common-outer-filter">
            {list && (
              <div className="btn-group new-cutom-filter show">
                <button
                  type="button"
                  onClick={() => setShowToggle(!showToggle)}
                  className={"btn dropdown-toggle mr-3"}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img alt="" src={pendingReq} width={"18px"} />
                </button>
                <div
                  className={`dropdown-menu dropdown-menu-right  ${
                    showToggle ? "show" : ""
                  }`}
                >
                  {list?.map((item, key) => (
                    <button
                      key={key}
                      className="dropdown-item"
                      onClick={() => toggle({ target: { value: item?.tabId } })}
                      type="button"
                    >
                      {item?.title}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {/* <SearchDate
              handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
              handleSearch={handleSearch}
              clearDate={handleClearDate}
            /> */}
          </div>
        </Col>
      </Row>

      {/* <Row className="justify-content-center mt--9">
        <Col md="6">
          <EmployeeSearchbar
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleSearch}
          />
        </Col>
        <Col md="6">
          <SearchDate
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleSearch}
          />
        </Col>
      </Row> */}

      <ApprovedListCard
        loader={fetchResultApprovedListRequestsLoader}
        fromSuperAdmin={true}
      />

      <div
        style={{
          display: fetchResultApprovedListRequestsLoader ? "none" : "contents",
        }}
      >
        <PaginationComponent
          totalCount={fetchResultApprovedListRequests?.itemCount}
          handlePagination={handlePagination}
          activePage={fetchResultApprovedListRequests?.activePage}
        />
      </div>
      {/* {! fetchResultApprovedListRequestsLoader && 
       <PaginationComponent totalCount={fetchResultApprovedListRequests?.itemCount} handlePagination={handlePagination}/>} */}
    </div>
  );
}

export default ApprovedList;
